import { Location } from "@angular/common";
import { AssignShippingDto } from "./assign-shipping-dto";
import { CustomerDeliveryAddress } from "./customerdeliveryaddress";
import { CustomerDto } from "./customerdto";
import { LocationDto } from "./locationdto";
import { LoginCustomerDetails } from "./logincustomerdetails";
import { ProductCartDto } from "./productcartdto";
import { ServiceMan } from "./serviceman";
import { WebOrderDetails } from "./weborderdetails";
import { WebOrderFeedBackDto } from "./weborderfeedbackdto";
import { WebOrderInvoiceDetailsDto } from "./weborderinvoicedetailsdto";
import { DispatchStorePickupDto } from "./dispatch-store-pickup-dto";
import { DeliveryFeedBackWebDto } from "./delivery-feed-back-web-dto";

export class WebOrderDto {
  orderNo: string;
  totalQty: number;
  totalAmount: number;
  orderStatus: string;
  currentStatus: string;
  refundStatus: string;
  customer: CustomerDto;
  //	private UpiPayment upiPayment;
  serviceMan: ServiceMan;
  webOrderDetails: WebOrderDetails[];
  createdDate: string;
  deliveryDate: string;
  deliveryTime: string;
  invoiceDetails: WebOrderInvoiceDetailsDto[];
  location: LocationDto;
  customerDeliveryDetails: CustomerDeliveryAddress;
  assignShippingDto: AssignShippingDto;
  deliveryFeedBackWebDto: DeliveryFeedBackWebDto;
  dispatchStorePickupDto: DispatchStorePickupDto;
  statusList: string[] = [];
  trackingStatus: string;
  isShippingCharge: boolean;
  otp: string;
  shippingForOrderNo: string;
  shippingDetails: any;
  deliveryStatus: string;
  invStatus: string;
}
